<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{'manage_stores' | translate}}</h3>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-sm-2">
                <div class="input-group">
                  <div class="input-group-addon">{{'status' | translate}}</div>
                  <select class="form-control" v-model="isActive" v-on:click.prevent="filter()">
                    <option value="all">{{'all' | translate}}</option>
                    <option value="1">{{'is_active' | translate}}</option>
                    <option value="0">{{'inactive' | translate}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{'status' | translate | capitalize}}</th>
                    <th>Ranking</th>
                    <th>{{'name' | translate | capitalize}}</th>
                    <th>{{'street' | translate | capitalize}}</th>
                    <th>{{'zip_code' | translate | capitalize}}</th>
                    <th>{{'city' | translate | capitalize}}</th>
                    <th>{{'country' | translate | capitalize}}</th>
                    <th>{{'details' | translate | capitalize}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stores">
                    <td v-if="item.is_active">
                      <span class="label label-success">
                        <i class="fa fa-check mr-5"></i>{{'is_active' | translate}}
                      </span>
                    </td>
                    <td v-else>
                      <span class="label label-danger">
                        <i class="fa fa-ban mr-5 mr-5"></i>{{'inactive' | translate}}
                      </span>
                    </td>
                    <td>{{item.ranking}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.street}}&nbsp;{{item.street_no}}</td>
                    <td>{{item.zip_code}}</td>
                    <td>{{item.city}}</td>
                    <td>{{item.country | country}}</td>
                    <td>
                      <router-link :to="`/management/stores/${item.id}`">
                        <b-btn class="btn btn-info btn-sm">
                          <i class="fa fa-edit mr-5"></i>
                          {{'edit_store' | translate($parent.$store.getters.language)}}
                        </b-btn>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Stores',
  data () {
    return {
      count: 25,
      stores: {},
      backup: [],
      alerts: [],
      isActive: 'all'
    }
  },
  methods: {
    filter () {
      let filter
      switch (this.isActive) {
        case '1':
          filter = true
          break
        case '0':
          filter = false
          break
      }
      this.stores = []
      if (this.isActive === 'all') {
        this.stores = this.backup
      } else {
        for (let x in this.backup) {
          if (this.backup[x].is_active === filter) {
            this.stores.push(this.backup[x])
          }
        }
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
        let self = this
        API.get('/accounting/stores')
          .then(response => {
            self.stores = response.data
            self.backup = response.data
            self.$store.commit('updateStores', self.stores)
          }, error => {
            this.$store.dispatch('checkError', error)
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            self.alerts.push(alert)
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Stores.vue